// extracted by mini-css-extract-plugin
export default {"message_container":"ErrorBoundary_message_container__PWlb5","text":"ErrorBoundary_text__Q6rFW","info":"ErrorBoundary_info__uZ2RD"};